require('./helpers/bundle-manifest').register(JSON.parse("{\"EVgbq\":\"index.4353fe69.js\",\"b3rV8\":\"josh_headshot.105cb8dc.jpg\"}"));